import { StylingWorkflowDTOType, StylingWorkflowListItemDTOType } from '../../../schemas/styling';
import { useReRunFailedWorkflowTasksMutation } from '../../../store/stylist/stylistApi';
import { Button, Space, Typography } from 'antd';

interface IReRunFailedTasksProps {
  workflow: StylingWorkflowDTOType | StylingWorkflowListItemDTOType;
}

const ReRunFailedTasks = ({ workflow }: IReRunFailedTasksProps) => {
  const [reRunFailedWorkflowTasks, { isLoading: isReRunning }] =
    useReRunFailedWorkflowTasksMutation({ fixedCacheKey: String(workflow.id) });

  const handleReRunFailedTasks = async (workflowId: number) => {
    try {
      await reRunFailedWorkflowTasks({
        workflowId,
      }).unwrap();
    } catch (error) {
      console.error('Failed to rerun workflow tasks:', error);
    }
  };

  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {workflow.failed_items} Failed Items
      </Typography.Text>
      <Button loading={isReRunning} onClick={() => handleReRunFailedTasks(workflow.id)}>
        Rerun
      </Button>
    </Space>
  );
};

export default ReRunFailedTasks;
